import { Form, FormikProvider, useFormik } from 'formik'
import React, { useEffect, useState } from 'react'
import CommonFormHeading from '../../CommonUtils/CommonFormHeading'
import * as bie from "react-bootstrap";
import { useNavigate } from 'react-router-dom';
import { CommonAxiosGet, CommonAxiosPost } from '../../CommonUtils/CommonAxios';
import { config } from '../../CommonUtils/CommonURLS';
import { useDispatch } from 'react-redux';
import { viewImage } from '../../CommonUtils/viewImage';
import { FcDownload } from "react-icons/fc";
import CommonReactTable from '../../CommonUtils/CommonReactTable';
import { BsFiletypePdf } from 'react-icons/bs';

export default function OamdcAfflOrderGen2023() {
    let navigated = useNavigate();
    const acYear = sessionStorage.getItem('ac_year');

    const dispatch = useDispatch();
    const handleNavigatefun = (collCode, type) => {
        navigated("/AfflOrderGenDetails", { state: { type: type } });
        dispatch({ type: "COLLEGE_CODE", payload: collCode });
    };
    const afflOrderGenFormik = useFormik({
        enableReinitialize: true,
        initialValues: {},
        validationSchema: "",
        onSubmit: (values) => {
        }


    })
    const [AfflorderData23, setAfflorderData23] = useState([]);
    function GetAfflOrderData23() {
        let url = config.url.API_URL + `oamdcAfflOrderReport `;
        CommonAxiosGet(url).then((res) => {
            if (res?.data?.scode === '01') {
                setAfflorderData23(res?.data?.oamdcAfflOrderReport)
            } else {
                setAfflorderData23([])

            }
        })

    }
    useEffect(() => {
        GetAfflOrderData23();
    }, [])
    function GetFfcaSubmissionPdf(collcode) {
        let url = config.url.API_URL + `getFfcaPdf/` + collcode + "/" + acYear;
        CommonAxiosPost(url).then((res) => {
            if (res?.data?.Status === true) {
                viewImage(res?.data?.path)
            } else {
                console.log("No Data Found")

            }
        })
    }

    function GetClgSubmissionPdf(collCode) {
        let payload = {}
        let url = config.url.API_URL + `getdegreepdf/${collCode}/${acYear}`
        CommonAxiosPost(url, payload, dispatch).then((res) => {
            if (res?.data?.Status === true) {
                viewImage(res?.data?.path)
            }
            else {
                console.log(res);
            }
        })
    }


    const CourseDataReportColumns23 = [
        { Header: "Sl.no", accessor: (row, index) => index + 1, },
        { Header: "College Code", accessor: "coll_code", },
        {
            Header: "College Name", accessor: "coll_name",

            Cell: ({ row }) => (
                <div style={{ textAlign: 'left' }}>{row?.values?.coll_name}</div>
            ),
        },
        { Header: "Nature Of the College", accessor: "coll_nature_name", },
        {
            Header: "College Submission Pdf",
            accessor: "",
            Cell: ({ row }) => {
                return (
                    <button type="button" className="btn btn  btn-md pt-1" style={{ color: "blue", textDecoration: "underline" }}
                        onClick={() => {
                            GetClgSubmissionPdf(row?.original?.coll_code)
                        }}>
                        <FcDownload color="red"
                            size={25} />
                    </button>
                )
            }
        },
        {
            Header: "FFCA Submission Pdf",
            accessor: '',
            Cell: ({ row }) => {
                return (
                    <button type="button" className="btn btn  btn-md pt-1" style={{ color: "blue", textDecoration: "underline" }}
                        onClick={() => {
                            GetFfcaSubmissionPdf(row?.original?.coll_code)
                        }}>
                        <FcDownload color="red"
                            size={25} />
                    </button>
                )
            }

        },
        {
            Header: "Cdc Approval Pdf", accessor: "cdc_file_path",
            Cell: ({ row }) => {
                return (
                    <button type="button" className="btn btn  btn-md pt-1" style={{ color: "blue", textDecoration: "underline" }}
                        onClick={() => {
                            viewImage(row?.original?.cdc_file_path);
                        }}>
                        <FcDownload color="red"
                            size={30} />
                    </button>
                )
            }
        },
        {
            Header: "Affiliation Order", accessor: "final_pdf_path",
            Cell: ({ row }) => {
                const value = row?.values?.final_pdf_path;
                // return <button type="button" className="btn btn  btn-md pt-1" style={{ color: "blue", textDecoration: "underline" }} onClick={() => { handleNavigatefun(row?.original?.coll_code, "OAMDC") }}>Click Here to get Affiliation Order </button>
                if (value === "Click Here to Generate Affiliation Order 2026-27") {
                    return <button type='button' className='btn btn-primary rounded-pill btn-sm' onClick={() => { handleNavigatefun(row?.original?.coll_code, "OAMDC") }}>  Click Here to get Affiliation Order</button>;
                } else {
                    return (
                        <button type="button" className="btn btn  btn-md pt-1"
                            onClick={() => {
                                viewImage(value);

                            }}>
                            <BsFiletypePdf color="red"
                                size={20} />
                        </button>
                    );
                }
            }
        }
    ]
    return (
        <>
            <CommonFormHeading heading="Approve and Generate Affiliation Order" />
            <bie.Container className="outer-page-content-container shadow-none px-3 m-0 mw-100 pb-5" style={{ backgroundColor: '#FAF7F0' }}>
                <FormikProvider value={afflOrderGenFormik}>
                    <Form onChange={afflOrderGenFormik?.handleChange} onSubmit={afflOrderGenFormik?.handleSubmit} className="form_adjust" >
                        {AfflorderData23?.length > 0 ? (

                            <bie.Row className="px-2 pt-3 mb-3 pb-3" style={{ border: '0.2px solid black' }}>
                                <div className="table-responsive">
                                    <CommonReactTable data={AfflorderData23} columns={CourseDataReportColumns23} pagination="false" filename="Oamdc_Affiliation_orderGeneration" headerName={`Oamdc Affiliation Order Generation`} />
                                </div>
                            </bie.Row>
                        ) : <center className='text-danger h5 pt-5'>*** No Data Found ***</center>}

                    </Form>
                </FormikProvider>
            </bie.Container>

        </>)

}
